import React from "react";
import { useTranslation } from "react-i18next";
import underlineimage from "../assets/images/title-shape.png";
import bgOverlay from "../assets/images/refer-friend-bg.jpg";
import androiddownloadimg from "../assets/images/playstorebtnlighttheme.png";
const SportsDraftAuction: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className="relative w-full py-16 px-4 bg-[#FFC700] overflow-hidden bg-cover bg-center"
      style={{
        backgroundImage: `url(${bgOverlay})`,
      }}
    >
      <div className="relative z-10 text-center mb-12">
        <h2 className="text-[32px] md:text-[48px] font-oswald font-extrabold text-[#070B28] leading-tight">
          {t("sportsDraftt.heading")}
        </h2>
        <img src={underlineimage} alt="underline" className="mx-auto mt-2 mb-6 w-[120px] h-auto" />
        {/* <p className="text-[18px] md:text-[20px] font-oswald font-medium max-w-2xl mx-auto mb-12 text-white leading-7">
      Get the thrill of becoming a team owner by participating in real auctions and bid for your favorite players
        </p> */}
        {/* <p className="text-[16px] md:text-[18px] font-proxima font-medium text-[#070B28] leading-relaxed mb-11">
       Get the thrill of becoming a team owner by participating in real auctions and bid for your favorite players
      </p> */}
        {/* <p className="text-[16px] md:text-[18px] font-proxima font-medium text-[#070B28] leading-relaxed">
          {t("sportsDraftt.description")}
        </p> */}
      </div>

      <div className="relative z-10 max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-center gap-[6rem] px-6">
        <div className="md:w-1/2">
          <div className="aspect-w-16 aspect-h-9 w-full">
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/RhdZy3vrEcg"
              title="GamerJi Tournament Services"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="rounded-lg shadow-lg"
            ></iframe>
          </div>
        </div>

        <div className="md:w-1/2 text-left">
          <p className="text-[28px] leading-[40px] font-semibold text-[#070B28] mb-[10px] font-proxima">
              {t("sportsDraftt.description")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SportsDraftAuction;
